import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    $(this.element).maskMoney({
      allowZero: true,
      decimal: ',',
      suffix: ' %',
      thousands: '.',
    });
  }
}
